import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface InvoiceItemDto {
  id: number;
  productId: number;
  quantity: number;
  soldPrice: number;
  soldDescription?: string;
  taxAmount?: number;
  discountAmount: number;
}

export interface InvoiceDto {
  id: number;
  organizationId: number;
  invoiceNumber: string;
  helcimInvoiceId?: string;
  currency: string;
  itemId: number;
  pickupDate: string;
  pickupName: string;
  type: string;
  totalTaxAmount: number;
  totalTaxDetails?: string;
  totalDiscountAmount: number;
  totalDiscountDetails?: string;
  dateCreated: string;
  dateUpdated: string;
  datePaid?: string;
  dateIssued: string;
  amount: number;
  amountPaid: number;
  amountDue: number;
  shippingAmount: number;
  shippingDetails?: string;
  tipAmount?: number;
  depositAmount: number;
  convenienceFee: number;
  convenienceFeeEnabled: boolean;
  notes?: string;
  token?: string;
  status?: string;
  items: InvoiceItemDto[];
}

export interface InvoiceItemWriteDto {
  productId: number;
  quantity: number;
  soldPrice: number;
  soldDescription?: string;
  taxAmount?: number;
  discountAmount: number;
}

export interface InvoiceCreateRequest {
  organizationId: number;
  invoiceNumber: string;
  helcimInvoiceId?: string;
  currency: string;
  itemId?: number;
  pickupDate?: string;
  pickupName?: string;
  type?: string;
  totalTaxAmount: number;
  totalTaxDetails?: string;
  totalDiscountAmount: number;
  totalDiscountDetails?: string;
  datePaid?: string;
  dateIssued?: string;
  amount: number;
  amountPaid: number;
  amountDue: number;
  shippingAmount: number;
  shippingDetails?: string;
  tipAmount?: number;
  depositAmount: number;
  convenienceFee: number;
  convenienceFeeEnabled: boolean;
  notes?: string;
  token?: string;
  status?: string;
  items: InvoiceItemWriteDto[];
}

export interface InvoiceUpdateRequest {
  helcimInvoiceId?: string;
  invoiceNumber?: string;
  currency?: string;
  itemId?: number;
  pickupDate?: string;
  pickupName?: string;
  type?: string;
  totalTaxAmount?: number;
  totalTaxDetails?: string;
  totalDiscountAmount?: number;
  totalDiscountDetails?: string;
  datePaid?: string;
  dateIssued?: string;
  amount?: number;
  amountPaid?: number;
  amountDue?: number;
  shippingAmount?: number;
  shippingDetails?: string;
  tipAmount?: number;
  depositAmount?: number;
  convenienceFee?: number;
  convenienceFeeEnabled?: boolean;
  notes?: string;
  token?: string;
  status?: string;
  contactName?: string;
  legalName?: string;
  billingBusinessName?: string;
  shippingBusinessName?: string;
  billingContactName?: string;
  billingContactEmail?: string;
  billingContactPhone?: string;
  billingAddress1?: string;
  billingAddress2?: string;
  billingCity?: string;
  billingState?: string;
  billingCountry?: string;
  billingZipCode?: string;
  shippingContactName?: string;
  shippingContactEmail?: string;
  shippingContactPhone?: string;
  shippingAddress1?: string;
  shippingAddress2?: string;
  shippingCity?: string;
  shippingState?: string;
  shippingCountry?: string;
  shippingZipCode?: string;
  items?: InvoiceItemWriteDto[];
}

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  private readonly http = inject(HttpClient);

  getAll(): Observable<InvoiceDto[]> {
    return this.http.get<InvoiceDto[]>('/api/invoices');
  }

  getById(id: number): Observable<InvoiceDto> {
    return this.http.get<InvoiceDto>(`/api/invoices/${id}`);
  }

  create(request: InvoiceCreateRequest): Observable<InvoiceDto> {
    return this.http.post<InvoiceDto>('/api/invoices', request);
  }

  update(id: number, request: InvoiceUpdateRequest): Observable<InvoiceDto> {
    return this.http.put<InvoiceDto>(`/api/invoices/${id}`, request);
  }
}
